import { createContext, useContext, useEffect, useState } from "react"
import { showNotify } from '../../Utils/Utils'
import { LogsInitContext } from "../LogsInitComponentesContext/LogsInitComponentesContext"
import { ConexaoServerContext } from "../ConexaoServerContext/ConexaoServerContext"
import { LogadoContext } from "../LogadoContext/LogadoContext"
import OneModal from "../../Components/OneModal/OneModal"
import { Box, Button } from "@mui/material"

let Ws = false
let wsRetryInterval = false
let wsFila = []

let routes = {}
export const WebSocketContext = createContext()

export const WebSocketProvider = ({ children }) => {
    const { LogInit } = useContext(LogsInitContext)
    LogInit('Websocket', 'contexto')

    const { getConfigServer } = useContext(ConexaoServerContext)
    const { logado } = useContext(LogadoContext)

    const [wsConectado, setWsConectado] = useState(false)
    const [openModalConexao, setOpenModalConexao] = useState(false)
    let timeout = null
    useEffect(() => {
        if (!Ws && logado) {
            ConectarWs()
        } else {
            closeWs()
        }
    }, [logado])

    const addRoute = (cmd, func) => {
        routes[cmd] = func
        if (cmd && typeof func == "function") {
            if (routes[cmd] === undefined) {
                routes[cmd] = func
            }
        }
    }

    async function ConectarWs() {
        if (!window.WebSocket) {
            console.log('SEM SUPORTE PARA WEBSOCKET')
            return false
        }

        let conection = await getConfigServer()

        // let urlWs = 'ws://192.168.235.50:3000/MO' /* Ativar somente para testes */
        let urlWs = `ws://${conection.ip}:${conection.porta_api}/MO`

        if (!Ws) {
            console.log('Conectando WS...')
            Ws = new WebSocket(urlWs)

            Ws.onopen = () => {
                console.log('WS Conectado !')
                clearRetryWS()
                setWsConectado(true)
                clearTimeout(timeout)
                setOpenModalConexao(false)
            }

            Ws.onclose = () => {
                console.log('Ws Desconectado!')
                if (sessionStorage.getItem('o_mo_user_logado')) {
                    retryWsConnection()
                }
            }

            Ws.onerror = (err) => {
                /** O error evento é disparado quando uma conexão com a WebSocket fechada devido a um erro (alguns dados não puderam ser enviados, por exemplo)
                * https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/error_event
                */
                console.log('Erro ao conectar WS: ', err)
                retryWsConnection()
            }

            Ws.onmessage = (message) => {
                let msg = JSON.parse(message.data)
                if (!msg.cmd) {
                    return false
                } else if (msg.cmd === 'conexao') {
                    let storage = sessionStorage.getItem('o_mo_user')
                    let id_session = localStorage.getItem('o_mo_id_session')
                    storage = (storage ? JSON.parse(storage) : storage)
                    const id_user = storage.id
                    if (id_user) {
                        sendWs('valida_cod_tk', { id_user, id_session })
                    }
                } else if (msg.cmd === 'valida_cod_tk') {
                    ProcessarFila()
                    sendWs('getAllEventosTela', {})
                    sendWs('getInternalLink', {})
                    addRoute('getInternalLink', setTipoLink)
                } else if (msg.cmd == 'notificar') {
                    console.error(msg.data.stack)
                    showNotify('error', msg.data.message)
                } else { // roteamento dinamico
                    for (const route in routes) {
                        if ((route === msg.cmd || route.split('#')[0] === msg.cmd) && typeof routes[route] === "function") {
                            routes[route](msg)
                        }
                    }

                    // if (typeof routes[msg.cmd] == "function") {
                    //     routes[msg.cmd](msg)
                    // }
                }
            }
        }
    }

    function ProcessarFila() {
        if (wsFila.length > 0) {
            wsFila.forEach((obj, i) => {
                sendWs(obj.cmd, obj.data)
                i = (i === 0 ? 1 : i)
                wsFila = wsFila.slice(1)
            })
        }
    }

    function retryWsConnection() {
        Ws = false
        if (!wsRetryInterval) {
            setWsConectado(false)
            if (sessionStorage.getItem('o_mo_user_logado')) {
                timeout = setTimeout(() => {
                    setOpenModalConexao(true)
                }, 5000)
            }
            wsRetryInterval = setInterval(() => {
                console.log('Tentando se conectar ao WS...')
                ConectarWs()
            }, 7000)
        }
    }

    function sendWs(cmd, data) {
        if (Ws && Ws.readyState == Ws.OPEN) {
            try {
                Ws.send(JSON.stringify({ conf: Ws.conf, cmd, data }))
            } catch (error) {
                console.log('Não foi possível enviar comando WS. Erro: ', (typeof error == 'object' ? JSON.stringify(error) : error))
            }
        } else {
            wsFila.push({ cmd, data })
        }

        if (Ws && (Ws.readyState == Ws.CLOSING || Ws.readyState == Ws.CLOSED)) {
            console.log('Não foi possível enviar comando, ws desconectado. ')
            retryWsConnection()
        }
    }

    /**
     * Envia comandos para o cortex. Parâmetro id_central é obrigatório
     * @param {String} cmd
     * @param {Object} data
     * @param {String} id_central
     * @returns {void}
     */
    function sendWsCortex(cmd, data, id_central) {
        if (!id_central) { return false }
        data._receiver_ = 'cortex'
        data.id_central = id_central
        sendWs(cmd, data)
    }

    function clearRetryWS() {
        clearInterval(wsRetryInterval)
        wsRetryInterval = false
    }

    function closeWs() {
        if (Ws) {
            Ws.close()
            Ws = false
        }
    }

    const handleCloseModalConexao = () => {
        clearTimeout(timeout)
        setOpenModalConexao(false)
    }

    const btnModalConexao = () => {
        return (
            <Box component='div' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button onClick={handleCloseModalConexao} color="one_primary" variant="contained" type="button">OK</Button>
            </Box>
        )
    }

    const setTipoLink = async (msg) => {
        /* DIGIFORT ESTÁ RETORNANDO CORS, DANDO PROBLEMA NESSE ESQUEMA, ENTÃO TEMPORÁRIAMENTE ESTÁ RETORNANDO SOMENTE 'INTERNO' */
        global.tipoLink = 'interno'
    }

    const value = { wsConectado, addRoute, sendWs, sendWsCortex }

    return (
        <WebSocketContext.Provider value={value}>
            <div>
                {openModalConexao && <OneModal
                    open={openModalConexao}
                    setOpen={setOpenModalConexao}
                    titleText="ATENÇÃO !"
                    FooterButtons={btnModalConexao}
                    onClose={() => {}}
                >
                    <Box component='div' sx={{ fontWeight: 400, display: 'flex', flexDirection: "column" }}>
                        <Box component='span'>
                            <Box component='span'>Houve um problema de conexão com o servidor.</Box>
                            <Box component='span' sx={{ fontWeight: 700, marginLeft: '5px' }}>O sistema não funcionará corretamente.</Box>
                        </Box>
                        <Box component='span' sx={{ marginTop: '10px' }}>Se o problema persistir informe o suporte</Box>
                    </Box>
                </OneModal>

                }
                {children}
            </div>
        </WebSocketContext.Provider>
    )
}
